/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { createAction } from 'redux-actions';

export const CREATE_WORKSPACE = 'workspace/CREATE_WORKSPACE';
export const DELETE_WORKSPACE = 'workspace/DELETE_WORKSPACE';
export const SELECT_WORKSPACE = 'workspace/SELECT_WORKSPACE';
export const UPDATE_SETTINGS_VALIDATION = 'workspace/UPDATE_SETTINGS_VALIDATION';
export const UPDATE_WORKSPACE = 'workspace/UPDATE_WORKSPACE';

export const createWorkspace = createAction(CREATE_WORKSPACE);
export const deleteWorkspace = createAction(DELETE_WORKSPACE);
export const saveWorkspace = createAction(UPDATE_WORKSPACE);
export const selectWorkspace = createAction(SELECT_WORKSPACE);
export const updateSettingsValidation = createAction(UPDATE_SETTINGS_VALIDATION);
